<template>
  <div class="label-options-data-dialog" :key="ids.elementInLayoutId">
    <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
        <div v-if="noCacheComponentLayout">
          <p>数据源类型</p>
        </div>
        <div class="mt4">
          <div v-if="!isLoginType" class="data-source-type">
            <cx-slider 
              v-if="isSubBindData"
              :value.sync="dataSourceType" 
              :options="dataSourceTypeOptions" 
              :height="32" />
            <cx-slider v-else 
              :value.sync="notLocal" 
              :options="dataOptions" 
              :height="32" />
          </div>
          <div v-show="(noCacheComponent && !noCacheComponentLayout && !isSubBindData) || (isSubBindData && dataSourceType === 'dataCenter')" :class="noCacheComponent && !noCacheComponentLayout ? 'mt12' : ''">
            <p class="mb2">数据源名称</p>
            <data-center-choose 
              :checkStatus="checkStatus"
              :myId="ids"
              :options="options"
              @onDataCenterChange="onDataCenterChange"
            />
          </div>
        </div>
      </el-collapse-item>
      <!-- 子页面(详情页/列表页数据绑定) -->
      <el-collapse-item
        v-if="isSubBindData && dataSourceType === 'bindData'"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="数据绑定"
        name="2"
      >
        <div v-if="pageType === 'detailPage'">
          <detailPageFieldMappingSetting :myid="ids" :options="options"></detailPageFieldMappingSetting>
        </div>
        <div v-else-if="pageType === 'listPage'">
          <listPageFieldMappingSetting :myid="ids" :options="options"></listPageFieldMappingSetting>
        </div>
      </el-collapse-item>
      <!-- 子页面(详情页/列表页数据绑定) -->
      <el-collapse-item
        v-if="!notLocal || (isSubBindData && dataSourceType === 'local')"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="内容"
        name="2"
      >
        <div class="setting-item">
          <div class="content">
            <div class="content-item verticallyCenter">
              <div
                class="edit-div"
                :contenteditable="options.appId?false:true"
                v-html="content"
                @blur="content = $event.target.innerHTML"
              ></div>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <!-- 自己外接数据源数据绑定 -->
      <el-collapse-item
        v-if="noCacheComponent && notLocal && restDataUrl && !showColsFieldMapping && dataSourceType !== 'bindData'"
        @mousedown.native="collapseMouseDown($event, '3')"
        title="数据绑定"
        name="3"
      >
      <div 
          v-if="restDataUrl && noCacheComponent"
          :class="currentFiledMappingChecked && currentFieldMappingFieldFlag ? 'mapping_content checked' : 'mapping_content'">
          <div class="verticallyBetweenCenter">
            <div class="content-title">
              文本
            </div>
            <el-checkbox v-model="options.isHyperlink">超链接</el-checkbox>
          </div>
          <div class="select_content mt8">
            <el-select style="width: 100%" v-model="fieldValue" placeholder="请选择" clearable>
              <el-option v-for="(item, index) in fieldList" :key="index" :label="item.label"
                :value="item.label">
                <span style="font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="verticallyCenter mapping_date_content mt8">
            <label class="date-label">显示为:</label>
            <el-dropdown trigger="click" @command="onChangeCurrentMappingType">
              <span class="el-dropdown-link">
                {{ currentFieldMappingDataTypeName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="custom-dropdown">
                <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
                  <div :class="currentFieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                    {{ item.label }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="select_content mt8" v-if="options.isHyperlink">
            <el-select style="width: 100%" v-model="currentFiledMapping.linkUrl" placeholder="请选择" clearable>
              <el-option v-for="(item, index) in fieldList" :key="index" :label="item.label"
                :value="item.label">
                <span style="font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="verticallyCenter mt4" v-if="options.isHyperlink">
            <el-checkbox v-model="options.openBlankPage">新页面打开</el-checkbox>
          </div>
        </div>
    
      </el-collapse-item>
      <!-- 自己外接数据源数据绑定 -->
      <!-- 单元格数据绑定 -->
      <el-collapse-item
        v-if="notLocal && showColsFieldMapping"
        @mousedown.native="collapseMouseDown($event, '3')"
        title="数据绑定"
        name="3"
      >
        <div class="select_content">
          <colsFieldMappingSetting v-if="!restDataUrl && showColsFieldMapping && !multiImageDetail" :ids="dataIds" :myId="ids" :options="options"></colsFieldMappingSetting>
          <multiImageFieldMappingSetting v-else-if="multiImageDetail" :myid="ids" :options="options"></multiImageFieldMappingSetting>
        </div>
      </el-collapse-item>
      <!-- 单元格数据绑定 -->
      <el-collapse-item
        v-if="(!isBigScreen && !showColsFieldMapping && !notLocal) || (isBigScreen && !noCacheComponentLayout)"
        @mousedown.native="collapseMouseDown($event, '4')"
        title="链接地址"
        name="4"
      >
        <div class="setting-item">
          <div class="font14 mb8">链接地址</div>
          <linkSet
            :linkAddress.sync="linkAddress"
            :internalLinkName.sync="internalLinkName"
            :subLinkName.sync="subLinkName"
            :linkUrl.sync="linkUrl"
            :accessRulers.sync="accessRulers"
            :openBlankPage.sync="openBlankPage"
            :isCustomLinkTo="true"
            :hasOrsUrl="hasOrsUrl"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="(!isBigScreen && !showColsFieldMapping && !notLocal) || (isBigScreen && !noCacheComponentLayout)"
        @mousedown.native="collapseMouseDown($event, '5')"
        title="更多"
        name="5"
      >
        <auto-update-timer/>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import detailPageFieldMappingSetting from "publicSetting/detailPageFieldMappingSetting.vue"
import listPageFieldMappingSetting from "publicSetting/listPageFieldMappingSetting.vue"
import multiImageFieldMappingSetting from "publicSetting/multiImageFieldMappingSetting.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import { isExist } from "utils"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
import dataToolMixin from "materials/dataToolMixin"

export default {
  name: "label-options-data",
  components: { widthAndSizeAndZindex, autoUpdateTimer, colsFieldMappingSetting, dataCenterChoose, detailPageFieldMappingSetting, listPageFieldMappingSetting, multiImageFieldMappingSetting },
  mixins: [dataToolMixin],
  props: {
    options: Object,
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      collapseActiveNames: ["1", "2", "3"],
      activeNames: ["1", "2", "3"],
      fetchEnd: false,
      dataTypeList: [
        {
          label: "字段名称+字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ],
      dataSourceTypeOptions: [{
        title: "本地数据",
        value: "local"
      }, {
        title: "数据中心",
        value: "dataCenter"
      }, {
        title: "数据绑定",
        value: "bindData"
      }],
      filedMappingList: [] // 用来做映射的字段集合
    }
  },
  computed: {
    isSubBindData() {
      return this.isSubPage && !this.showColsFieldMapping
    },
    isSubPage() {
      return ['detailPage', 'listPage'].includes(this.pageType)
    },
    currentFieldMappingDataTypeName() {
      const item = this.dataTypeList.find(data => data.value === this.currentFieldMappingDataType)
      return item?.label || ""
    },
    dataSourceType: {
      get() {
        if (!this.options.dataSourceType && this.options.restDataUrl) {
          return 'dataCenter'
        } else return this.options.dataSourceType || 'local'
      },
      set(newVal) {
        if (newVal === 'dataCenter') {
          this.detailFieldMapping = {}
          this.currentFieldMappingFieldFlag = ""
          this.noCacheComponent = true
        } else if (newVal === 'local') {
          this.detailFieldMapping = {}
          this.currentFiledMapping = {}
          this.fieldValue = ''
          this.restDataUrl = ''
          this.noCacheComponent = false
        } else if (newVal === 'bindData') {
          this.noCacheComponent = true
          this.detailFieldMapping = {
            fieldFlag: "",
            isChecked: true,
            linkUrl: '',
            dataType: "dataValue"
          }
          this.currentFiledMapping = {}
          this.fieldValue = ''
        }
        this.$changeOptionsEV(newVal, "dataSourceType", false)
      }
    },
    fieldMappingDataType: {
      get() {
        return this.filedMapping?.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping.dataType", false, null, {
          ...this.ids
        })
      }
    },
    currentFieldMappingDataType: {
      get() {
        return this.currentFiledMapping?.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.dataType", false, null, {
          ...this.ids
        })
      }
    },
    fieldMappingDataTypeName() {
      const item = this.dataTypeList.find(data => data.value === this.fieldMappingDataType)
      return item?.label || ""
    },
    currentFiledMapping: {
      get() {
        return this.options.currentFiledMapping
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping", false)
      }
    },
    currentFiledMappingChecked: {
      get() {
        return this.options.currentFiledMapping?.isChecked || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.isChecked", false)
      }
    },
    currentFieldMappingFieldFlag: {
      get() {
        return this.options.currentFiledMapping?.fieldFlag
      },
      set(newVal) {
        if (!this.currentFiledMapping) {
          this.currentFiledMapping = {}
        }
        if (!this.currentFiledMappingChecked) {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
          this.$changeOptionsEV(true, "currentFiledMapping.isChecked", false, false, false, true)
        } else {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
        }
      }
    },
    detailFieldMapping: {
      get() {
        return this.options.detailFieldMapping
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "detailFieldMapping", false)
      }
    },
    filedMapping: {
      get() {
        return this.options.filedMapping
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
        // 如果在详情页中文本组件选中外接数据源，需要先初始化文本组件在详情页的相关对象属性detailFieldMapping，同时给文本组件增加在详情页中请求数据源的插件
        // 切换到本都数据的时候，清除之前绑定的appId
        if (!newVal) {
          this.$changeOptionsEV("", "appId", false, false, false, true)
        }
        if (newVal) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataKey",
              fieldFlag: ""
            },
            "currentFiledMapping",
            false,
            false,
            false,
            true
          )
        }
      }
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    isLoginType(){
      return this.options.loginType
    },
    notLocal: {
      get() {
        // 自由布局的单元格中
        if(this.noCacheComponentLayout) {
          return !!this.options.filedMapping?.value
        } else {
          return this.noCacheComponent
        }
      },
      set(newVal) {
        if(this.noCacheComponentLayout) {
          if (!this.filedMapping) this.filedMapping = {}
          this.$changeOptionsEV(newVal ? "0" : "", "filedMapping.value", false)
        } else {
          // 如果切到了数据中心，先清掉
          this.linkUrl = "" 
          
        }
        this.noCacheComponent = newVal
        if (!newVal) {
          // 切换到本地数据
          !this.showColsFieldMapping && (this.fieldValue = "")
          this.restDataUrl = ""
          this.currentFiledMapping = {}
          this.isHyperlink = false
        }
      }
    },
    dataOptions() {
      const options = [{ value: false, title: "本地数据" }]
      if (this.pageType === "detailPage" || this.pageType === "listPage" || this.showColsFieldMapping) {
        options.push({ value: true, title: "数据绑定" })
      } else if((this.isBigScreen && !this.noCacheComponentLayout) || (!this.isBigScreen && !this.showColsFieldMapping)) {
        options.push({ value: true, title: "数据中心" })
      }
      return options
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    restDataUrl: {
      get() {
        return this.options.restDataUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    fieldValue: {
      get() {
        return this.options.fieldValue
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fieldValue", false)
      }
    },
    fieldList: {
      get() {
        return this.options.fieldList || []
      }
    },
    content: {
      get() {
        let content = this.options.content?.replace(/(<br>)*$/g, "") //替换末尾换行符
        return content
      },
      set(newVal) {
        newVal = String(newVal).replace(/<[^>]+>/g, "<br>")
        this.$changeOptionsEV(newVal, "content", false, undefined, this.originalIds)
      }
    },
    internalLinkName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "internalLinkName", "internalLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "internalLinkName", false)
      }
    },
    subLinkName: {
      get(val) {
        return this.checkAndSetPrimaryVal(this.options, "subLinkName", "subLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "subLinkName", false)
      }
    },
    linkAddress: {
      get() {
        return this.options.linkAddress || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkAddress", false)
      }
    },
    linkUrl: {
      get() {
        return this.options.linkUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkUrl", false)
      }
    },
    accessRulers: {
      get() {
        return this.options.accessRulers ? this.options.accessRulers : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "accessRulers", false)
      }
    },
    openBlankPage: {
      get() {
        return this.options.openBlankPage
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openBlankPage", false)
      }
    },
    showColsFieldMapping() {
      return this.dataIds?.uid || isExist(this.dataIds?.elementInSwiperId) || this.dataIds?.elementInDataGridId
    },
    hasOrsUrl() {
      if(this.restDataUrl){
        return true
      }else{
        return false
      }
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.dataIds)
    }
  },
  methods: {
    onChangeCurrentMappingType(value) {
      this.currentFieldMappingDataType = value
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect.call(this, datas => {
        const data = datas[0]
        let fieldList = []
        if (data) {
          Object.keys(data).map((key, item) => {
            if (Object.prototype.toString.call(data[key]) === "[object Object]") {
              // 判断是否为Object
              const param = {
                label: data[key].key,
                value: data[key].value
              }
              fieldList.push(param)
            }
          })
        }
        this.$changeOptionsEV(fieldList, "fieldList", false, false, false, true)
      })
    },
    onDataCenterChange() {
      if(!this.showColsFieldMapping) {
        this.getBaseModuleDataLoop()
      }
    },
    updateToolbarData() {
      if(!this.showColsFieldMapping) {
        this.getBaseModuleDataLoop()
      }
    }
  },
  mounted() {
    this.originalIds = JSON.parse(JSON.stringify(this.$store.state.states.activeID))
    if (this.noCacheComponentLayout && !this.isBigScreen) {
      this.noCacheComponent = false
    }
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  updated() {
    this.originalIds = JSON.parse(JSON.stringify(this.$store.state.states.activeID))
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  }
}
</script>

<style lang="scss" scoped>
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);

  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }

  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }

  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }

    .select-name {
      font-size: 13px;
      background-color: var(--inputBackGround);
      border-radius: 4px;
      height: 32px;
      line-height: 22px;
      padding: 5px 0 5px 12px;
    }
  }

  &.checked {
    .select_content {
      .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;

        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }

      .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }

      .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }

      .select-name {
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
      }
    }
  }

  .mapping_date_content {
    height: 20px;

    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }

    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }

  .el-checkbox {
    margin-right: 4px;
  }

  .vedio-style {
    font-size: 13px;
  }
}

.bigScreen {
  .mapping_content {
    color: rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 0.08);
    background-color: rgba(40, 42, 46, 1);
    &.checked,
    &:hover {
      border-color: rgba(166, 139, 255, 0.16);
      background-color: rgba(166, 139, 255, 0.04);
    }
    .select_content {
      ::v-deep .el-input__inner {
        background-color: rgba(31, 33, 36, 1);
        box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.08) inset;
      }
    }
    &.checked {
      .select_content {
        ::v-deep .el-input__inner {
          background-color: rgba(166, 139, 255, 0.1);
          color: rgba(166, 139, 255, 1);
          box-shadow: 0px 0px 0px 1px rgba(166, 139, 255, 0.16) inset;
          &:hover {
            background-color: rgba(166, 139, 255, 0.2);
          }
        }
        ::v-deep .el-select__caret {
          color: rgba(166, 139, 255, 1);
        }
        ::v-deep .is-focus .el-input__inner {
          background-color: rgba(166, 139, 255, 0.2);
        }
      }
    }
  }
}

.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item {
  input {
    width: 252px;
    height: 32px;
    background: #35383f;
    color: rgba(255, 255, 255, 0.2);
  }
  .tips {
    color: var(--thirdTextColor);
  }
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
  &:hover {
    cursor: pointer;
  }
}
.edit-div {
  width: 100%;
  background-color: var(--inputBackGround);
  border: var(--inputBorder);
  box-sizing: border-box;
  border-radius: 4px;
  min-height: 60px;
  max-height: 156px;
  padding: 6px 12px;
  &:focus {
    outline: none;
    border: 1px solid var(--themeColor);
  }
}
</style>
